<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <ItemsWaiting v-if="is_fetch"/>
    <div v-else style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="d-flex justify-content-between">
        <div class="text-right m-4">
          <h5 style="font-size: 1vw !important"> ریشه علل مسئله </h5>
        </div>
        <div class="d-flex" v-if="allItems.length">
          <a style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1"
             v-if="seconder_ban || approver_ban" v-show="!status_show" @click="infoCancelledModal=true"> دلایل عدم
            تایید</a>


          <!--          <a   :href="`${this.download_url}/rootCauses/all/pdf/by/id/${id_user}?token=${$cookies.get('id_login')}`"
                       style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی
                      PDF</a>-->

        </div>

      </div>
      <center v-if="status_approver">
        <div class="alert alert-success w-25">
          تایید نهایی!
        </div>
      </center>
      <center v-if="!status_show && allItems.length">

        <div v-if="seconder_ban" class="alert alert-warning w-50" @click="infoCancelledModal=true">
          <div v-if="this.$cookies.isKey('type_2')">
            کاربرگ توسط مدیر ؛ تایید نشد!
          </div>
          <div v-else>
            این کاربرگ قبلا توسط شما رد شده است و در حال حاضر اصلاح شده است

          </div>
        </div>
      </center>
      <center v-if="!status_show">
        <div v-if="approver_ban" @click="infoCancelledModal=true" class="alert alert-info" style="width: 30vw;">
          کاربرگ توسط مدیر سامانه ؛ تایید نشد!
        </div>
      </center>
      <center v-if="status_seconder_step">
        <div v-if="status_seconder" class="alert alert-info w-50">
          در انتظار تایید توسط مدیر
        </div>
        <div v-if="!status_seconder" class="alert alert-info" style="width: 24vw;">
          در انتظار تایید توسط مدیر سامانه
        </div>
      </center>
      <div class="table-responsive p-5">
        <center v-show="!allItems.length">
          <span v-if="$cookies.isKey('type_2') && isWrite">ریشه علل مسئله وجود ندارد</span>
          <span v-else-if="!isWrite">دوره ای برای  پایش بهره وری این شرکت فعال نمی باشد
</span>
          <span v-else>
            در انتظار تکمیل کاربرگ توسط دبیرکمیته بهره وری
          </span>
        </center>
        <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

          <table v-show="allItems.length" class="table table-striped bg-white">
            <tbody>
            <tr>
              <th rowspan="2"><strong>ردیف</strong></th>


              <th rowspan="2"><strong>مسئله
                (به ترتیب اولویت)
              </strong></th>
              <th rowspan="2"><strong> روش ریشه‌یابی </strong></th>
              <th style="width: 4vw;"><strong>عوامل ریشه‌ای</strong></th>

            </tr>
            <tr>


            </tr>
            <tr v-for="(item,index) in allItems">
              <td style="width: 1vw;">{{ index + 1 }}</td>
              <td>{{ item.problem_identifications && item.problem_identifications.title }}</td>
              <td style="width: 11vw;">

                <select v-model="item.method"  :value="item.root_causes_problem && item.root_causes_problem.method" name=""
                        :id="`method_${item.id}`" class="form-select">
                  <option value="RCA+"> RCA+</option>
                  <option value="RCA"> RCA</option>

                  <option value="استخوان ماهی">استخوان ماهی</option>
                  <option value="  تحلیل علت و معلولی"> تحلیل علت و معلولی</option>
                  <option value=" 5 چرا"> 5 چرا</option>
                  <option value="سایر">سایر</option>
                </select>
                <input class="form-control mt-2"  type="text" v-if="item.method==='سایر'" :id="`order_text_${item.id}`" :value="item.order_text">
              </td>
              <td>
                <button v-if="show_insert" @click="modalSaveModal(item.id)" class="btn btn-primary btn-submit-1">
                  تکمیل/بروزرسانی
                </button>
                <button v-else @click="modalSaveModal(item.id)" class="btn btn-primary btn-submit-1"> مشاهده</button>
              </td>


            </tr>


            </tbody>
          </table>
        </div>
      </div>
      <center v-if="show_insert && not_show">
        <button
            v-show="allItems.length"
            @click="store"
            style="margin-top: 1.3vw;margin-left: 2vw;  margin-bottom: 1vw;" class="btn btn-primary btn-submit-1">ذخیره
        </button>
      </center>
      <br>
      <hr v-if="allItems.length">
      <div v-if="allItems.length" class="d-flex align-items-center justify-content-center mb-4">
        <a :href="`${this.download_url}/rootCauses/all/word/by/id/${id_user}?token=${$cookies.get('id_login')}`"
           style="margin-left: 1vw;margin-top: 1.3vw;"
           class="btn btn-primary btn-submit-1">خروجی Word</a>
        <p @click.prevent="exportDocs" style="margin-left: 1vw;margin-top: 2.5vw;"
           class="btn btn-primary btn-submit-1">خروجی مستندات</p>
        <a
            v-if="not_show"
            :style="$cookies.isKey('type_2') ? 'width: 10vw': ''"
            style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green"
            class="btn btn-primary btn-submit-1 "


        >
          <div v-if="!status_loading">

            <span @click="acceptComplete" v-if="!$cookies.isKey('type_2')">  تایید </span>
            <span @click="acceptCompleteModal=true" v-else>    ارائه جهت تایید مدیر</span>

          </div>

          <div v-else>
            <div class="loader-line"></div>

          </div>
        </a>
        <div dir="rtl" class="modal__error slide-top" v-show="acceptCompleteModal"
             style="z-index: 999999999999999; top: 40%;">
          <div>
            <p>اخطار</p>
            <p @click="acceptCompleteModal=!acceptCompleteModal">❌</p>
          </div>
          <div>
            <p>آیا از ارائه به مدیر مطمئن هستید؟</p>

            <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
              <button @click="acceptCompleteModal=!acceptCompleteModal" class="btn btn-primary btn-back" type="submit">
                برگشت
              </button>
              <button class="btn btn-primary btn-approve" @click="acceptComplete">تایید</button>
            </div>
          </div>
        </div>
        <a v-if="!$cookies.isKey('type_2') && not_show"
           style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  "
           class="btn btn-primary btn-submit-1 "
           @click="acceptComplete2"
        >
          <div v-if="!status_loading2">
            <span>عدم تایید</span>
          </div>

          <div v-else>
            <div class="loader-line"></div>

          </div>
        </a>
      </div>

    </div>
  </div>
  <div v-show="modalSave" class="modal__error slide-top" style="width: 50vw; z-index: 9999">
    <div class="d-flex justify-content-between flex-row-reverse">
      <p @click="modalSave = !modalSave">❌</p>
      <p>عوامل ریشه‌ای</p>
    </div>

    <div class="d-flex flex-column align-items-start" style="width: 100%;" dir="rtl" v-if="show_insert && not_show">
      <!-- Inputs Section -->
      <div class="d-flex flex-row align-items-start justify-content-between" >
        <div class="col-6" style="width: 22vw;">
          <label class="required">عامل ریشه‌ای</label>
          <input v-model="title_root" type="text" class="form-control text-right">
        </div>
        <div class="col-6" style="width: 23vw; margin-right: 2vw;">
          <label class="required">نوع</label>
          <select v-model="type_root" class="form-select text-right">
            <option value="بازدارنده">بازدارنده</option>
            <option value="پیشران">پیشران</option>
          </select>
        </div>
      </div>

      <!-- Checkboxes Section -->
      <div class="d-flex flex-row-reverse justify-content-between w-100 align-items-center mt-3">
        <label class="d-flex align-items-center">
          <input v-model="is_human_root" type="checkbox" class="form-check mx-2"> نیروی انسانی
        </label>
        <label class="d-flex align-items-center">
          <input v-model="money_root" type="checkbox" class="form-check mx-2"> سرمایه
        </label>
        <label class="d-flex align-items-center">
          <input v-model="tech_root" type="checkbox" class="form-check mx-2"> فناوری
        </label>
        <label class="d-flex align-items-center">
          <input v-model="management_root" type="checkbox" class="form-check mx-2"> مدیریت
        </label>
      </div>

      <!-- Additional Input -->
      <div class=" mt-3" style="width: 100%;">
        <label>سایر</label>
        <textarea v-model="other_root" class="form-control text-right" cols="30" rows="10"></textarea>
      </div>

      <!-- Buttons -->
      <div class="d-flex justify-content-center mt-4 align-items-center justify-content-center w-100 mb-2 mt-2"
          >
        <div class="d-flex">
          <button v-if="!is_update" @click.prevent="store_root(id_root)" class="btn  mx-2 btn-primary btn-submit-1">ذخیره
          </button>
          <button v-else @click.prevent="update(id_item)" class="btn btn-primary mx-2 btn-submit-1">ویرایش</button>
          <Reset style="width: 1.5vw; height: 1.5vw;" @click.prevent="resetItems" class="btn-reset"></Reset>
        </div>
      </div>
    </div>

    <hr v-if="show_insert">

    <!-- Table Section -->
    <div style="overflow-y: scroll; height: 14vw;" class="mt-2">
      <table v-if="allItemsOther.length" class="table table-striped bg-white text-right">
        <thead>
        <tr>
          <th>ردیف</th>
          <th>عامل ریشه‌ای</th>
          <th>نوع</th>
          <th>نیروی انسانی</th>
          <th>سرمایه</th>
          <th>فناوری</th>
          <th>مدیریت</th>
          <th>سایر</th>
          <th>عملیات</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in allItemsOther" :key="item.id">
          <td>{{ index + 1 }}</td>
          <td>{{ item.title }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.is_human ? '✅' : '' }}</td>
          <td>{{ item.is_fund ? '✅' : '' }}</td>
          <td>{{ item.is_technology ? '✅' : '' }}</td>
          <td>{{ item.is_management ? '✅' : '' }}</td>
          <td>{{ item.other }}</td>
          <td>
            <div class="d-flex justify-content-around">
              <a @click.prevent="editMethod(item.id)" href="#">🖊️</a>
              <a @click.prevent="deleteMethod(item.id)" href="#">❌</a>
              <a @click.prevent="AddDocumentMethod(item.id, item.title)" href="#">📤</a>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <center v-else>موردی یافت نشد</center>
    </div>

    <!-- Delete Confirmation Modal -->
    <div class="modal__error" v-show="deleteModal" style="z-index: 999999; top: 40%;">
      <div class="d-flex justify-content-between">
        <p>حذف</p>
        <p @click="deleteModal = !deleteModal">❌</p>
      </div>
      <p>آیا می‌خواهید حذف کنید؟</p>
      <div class="d-flex justify-content-around mt-4">
        <button @click="deleteModal = !deleteModal" class="btn btn-secondary">برگشت</button>
        <button @click="deleteItemForm(id_item)" class="btn btn-danger">تایید</button>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelledModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>دلایل عدم تایید</p>
      <p @click="infoCancelledModal=!infoCancelledModal">❌</p>
    </div>
    <div>
      <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{ textAlert }}</p>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showReSubmit=false" class="btn btn-primary btn-back" type="submit">برگشت</button>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="showReSubmit" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>آیا مطمئن هستید تمامی موارد مشکل دار را رفع کرده اید؟</p>
      <p @click="showReSubmit=!showReSubmit">❌</p>
    </div>
    <div>
      <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{ textAlert }}</p>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showReSubmit=false" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button @click="acceptComplete4" class="btn btn-primary btn-submit-1" type="submit">تایید نهایی</button>
      </div>
    </div>
  </div>

  <div class="modal__error bg-white" style="z-index: 10000000; direction: rtl; width: 54vw; overflow-y: scroll; height: 35vw;" v-show="documentsModal">
    <div  class="d-flex justify-content-between">
      <p>مستندات</p>
      <p id="btn2_p" @click.prevent="closeModal()">❌</p>
    </div>
    <hr>
    <div class="d-flex flex-column" v-if="not_show && show_insert">
      <label class="required text-end">     عنوان مستندات پیوست  </label>
      <input id="title" v-model="title_attach" type="text" class="form-control">
    </div>
    <div class="d-flex flex-column" v-if="not_show && show_insert">
  <label class="required text-end">فایل پیوست</label>
  <label class="input input--file">
    <input
      id="file"
      type="file"
      class="input__field"
      accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .csv"
      required
      @change="handleFileChange"
    >
    <span class="input__support">
      <span STYLE="color: #7d8a96;direction: ltr;" class="input__helper">{{ file_name }}</span>
    </span>
  </label>
</div>

    <div id="showBar" style="display:none;">
      <div class="progress">
        <div class="progress-bar" role="progressbar" id="progress_bar"  :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <p id="progress"></p>
    </div>
    <center class="my-2" v-if="not_show">
      <button id="btn_p" @click="addDocs" class="btn btn-primary btn-submit-1">افزودن </button>
      <hr class="my-3 w-100" v-if="show_insert">
    </center>
    <div style="font-size: 1vw;color: #a7a3a3;" v-if="isLoadingDocuments" class="text-center my-3">در حال دریافت اطلاعات...</div>
    <div style="font-size: 1vw;color: #a7a3a3;" v-else-if="!documents.length" class="text-center my-3">موردی یافت نشد!</div>
    
    <table  class="table table-striped bg-white" v-else>
      <thead >
      <tr>
        <th ><strong> عنوان مستند    </strong></th>
        <th><strong>فایل مستند</strong></th>
        <th v-if="show_insert" style="width: 1vw;"><strong>عملیات  </strong></th>
      </tr>
      </thead>
      <tbody>

      <tr class="bg-white" v-for="(item) in documents">
        <td>{{item.text}}</td>
        <td>
          <a :href="`${this.download_url}/${item.file}`" target="_blank">مشاهده</a>
        </td>
        <td v-if="show_insert">
          <a @click.prevent="deleteMethodFile(item.id)" style="margin-right: 0.3vw;"   href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>

        </td>
      </tr>
      </tbody>


    </table>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="delete_fileModal" style="z-index: 999999999999999; top: 40%;">
    <div class="d-flex justify-content-between w-100">
      <p>حذف</p>
      <p @click="delete_fileModal=!delete_fileModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="delete_fileModal=!delete_fileModal" class="btn btn-primary btn-back" type="submit">برگشت
        </button>
        <button class="btn btn-primary btn-approve" @click="deleteMethodFileSubmit(id_file)">تایید</button>
      </div>
    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import {useToast} from "vue-toastification";
import router from "@/router";
import Reset from "@/components/Icons/Reset.vue";
import ItemsWaiting from "@/components/Loaders/ItemsWaiting.vue";
import cookies from "vue-cookies";

const toast = useToast();

export default {
  computed: {
    cookies() {
      return cookies
    }
  },
  components: {
    ItemsWaiting,
    Reset,
    Sidebar,
    splash
  },
  data() {
    return {
      isLoadingDocuments: false,
      status_loading2: false,
      acceptCompleteModal: false,
      showReSubmit: false,
      isWrite: false,
      allItems: [],
      allItemsOther: [],
      id_user: '',
      other_root: '',
      management_root: '',
      tech_root: '',
      money_root: '',
      is_human_root: '',
      type_root: '',
      title_root: '',
      id_root: '',
      id_item: '',
      modalSave: false,
      deleteModal: false,
      is_update: false,
      status_show: false,
      status_loading: false,
      show_insert: false,
      status_seconder: false,
      status_approver: false,
      infoCancelled: false,
      text_info: '',
      seconder_ban: false,
      approver_ban: false,
      textAlert: '',
      infoCancelledModal: false,
      status_seconder_step: false,
      documents: [],
      documentsModal: false,
      title_attach: '',
      id_file: '',
      progress: '',
      delete_fileModal: false,
      is_fetch: true,
      not_show: true,
      
    file_name: '',


    }
  },
  methods: {

    exportDocs() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/rootCauses/export_doc`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.download_link) {
              // ایجاد یک المان a مخفی برای دانلود
              const link = document.createElement('a');
              link.href = response.download_link;
              link.download = 'documents.zip'; // یا هر نام دیگری که می‌خواهید
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              toast.info('دانلود شروع شد');
            } else if (response.error) {

              // نمایش پیام خطا به کاربر
              toast.error('خطا در دریافت فایل: ' + response.error);
            }
          })
          .catch(error => {
            toast.error('خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.');
          });
    },
    closeModal(){
  
    this.documentsModal=!this.documentsModal ; 
    this.title_attach="";
    this.file_name = '';
     document.querySelector('#title').value = '';
          document.querySelector('#file').value = '';
          this.documents.length=0
},
    deleteMethodFileSubmit(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/rootCauses/remove_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const message = response.message
            if (message) {
              toast.success(message)
              this.delete_fileModal = false
              this.id_file = ''
              this.allDocsMethod(response.id)

            }
          })
          .catch();
    },
    allDocsMethod(id) {
      this.isLoadingDocuments = true;
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/all_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.isLoadingDocuments = false;
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.documents.length = 0
            response.all.forEach((item) => {
              this.documents.push(item)
              this.isLoadingDocuments = false;
            })


          })
          .catch();
    },

    handleFileChange(event) {
    const file = event.target.files[0];
    this.file_name = file ? file.name : '';
  },
    deleteMethodFile(id) {
      this.id_file = id
      this.delete_fileModal = true
    },
    addDocs() {
  const token = this.$cookies.get('token');
  const fileInput = document.querySelector('#file');
  const file = fileInput.files[0];
  const formdata = new FormData();
  formdata.append('text', this.title_attach);
  formdata.append('file', file);
  formdata.append('id', this.id);

  const xhr = new XMLHttpRequest();
  xhr.open('POST', `${this.base_url}/rootCauses/add_doc`, true);
  xhr.setRequestHeader("Authorization", `Bearer ${token}`);

  const self = this; // ← برای استفاده از `this` داخل توابع داخلی

  xhr.upload.onprogress = function (event) {
    if (event.lengthComputable) {
      document.getElementById("showBar").style.display = 'block';
      document.getElementById("btn2_p").style.visibility = 'hidden';
      document.getElementById("btn_p").style.visibility = 'hidden';
      const progress = ((event.loaded / event.total) * 100).toFixed();
      document.getElementById("progress").innerText = `${progress}%`;
      document.getElementById("progress_bar").style.width = `${progress}%`;
    }
  };

  xhr.onreadystatechange = function () {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      document.getElementById("showBar").style.display = 'none';
      document.getElementById("btn2_p").style.visibility = 'visible';
      document.getElementById("btn_p").style.visibility = 'visible';

      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);

        if (response.error) {
          toast.error(response.error);
          return;
        }

        toast.success(response.message);

        // اگر سرور فایل جدید رو برمی‌گردونه، اضافه کن به لیست
        if (response.data) {
          self.documents.unshift(response.data); // اضافه کردن به اول لیست
        } else {
          self.allDocsMethod(self.id); // اگر چیزی برنگشت از سرور، بگیر دوباره کل لیست رو
        }

        // پاک کردن فیلدها
        self.title_attach = '';
        document.querySelector('#title').value = '';
        fileInput.value = '';
        self.selectedFileName = ''; // اگر فیلد نمایش اسم فایل داری
          self.file_name = '';
          // پاک کردن مقادیر
          this.title_attach = '';
          document.querySelector('#title').value = '';
          document.querySelector('#file').value = '';
      } else {
        console.error('Upload error:', xhr.status);
        toast.error('خطا در بارگذاری فایل');
      }
    }
  };

  xhr.send(formdata);
}
,
    AddDocumentMethod(id, title) {
      this.documentsModal = true
      this.id = id
      this.allDocsMethod(id)
    },


    // *************************************
    // *************************************
    setShow() {
      if (this.$cookies.isKey('type_2')) {
        if (this.status_show === false) {
          this.show_insert = true
          return;
        }
        this.show_insert = true
      }
      this.show_insert = false
    },
    acceptComplete() {
      this.acceptCompleteModal = false
      if (this.status_show) {
        return;
      }
      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      if (this.seconder_ban || this.approver_ban) {
        this.showReSubmit = true
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    acceptComplete4() {
      this.acceptCompleteModal = false
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading = false
              this.all()
            }
            this.infoCancelled = false
            this.showReSubmit = false

          })
          .catch();
    },
    acceptComplete2() {

      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },
    acceptComplete3() {
      this.status_loading2 = true
      if (!this.status_show) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info) {
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/rootCauses/update_complete`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading2 = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    editMethod(id) {
      this.is_update = true
      this.id_item = id
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/rootCauses/save_RootCausesProblemAnalysis/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const item = response.item


            this.is_update = true

            if (item) {
              this.title_root = item.title
              this.type_root = item.type
              this.is_human_root = item.is_human ? true : false
              this.money_root = item.is_fund ? true : false
              this.tech_root = item.is_technology ? true : false
              this.management_root = item.is_management ? true : false
              this.other_root = item.other

            }
          })
          .catch();

    },
    update(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('title', this.title_root)
      formdata.append('type', this.type_root)
      formdata.append('is_human', this.is_human_root === true ? 1 : 0)
      formdata.append('is_fund', this.money_root === true ? 1 : 0)
      formdata.append('is_technology', this.tech_root === true ? 1 : 0)
      formdata.append('is_management', this.management_root === true ? 1 : 0)
      if (this.other_root){
      formdata.append('other', this.other_root)

      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/save_RootCausesProblemAnalysis/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.resetItems()
            this.fetchOther(response.id)


          })
          .catch();

    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/rootCauses/save_RootCausesProblemAnalysis/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.message) {
              toast.success(response.message)
              this.fetchOther(response.id)
              this.id_item = ''
              this.deleteModal = false

            }
          })
          .catch();
    },
    deleteMethod(id) {
      this.id_item = id
      this.deleteModal = true
    },

    resetItems() {
      this.resetData()
      this.is_update = false
      this.id_item = ''
    },
    resetData() {
      this.other_root = ''
      this.management_root = 0
      this.tech_root = 0
      this.money_root = 0
      this.is_human_root = 0
      this.type_root = ''
      this.title_root = ''


    },
    modalSaveModal(id) {
      this.resetData()
      this.modalSave = true
      this.id_root = id
      this.fetchOther(id)
    },
    fetchOther(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/save_RootCausesProblemAnalysis/all/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.allItemsOther.length = 0
            response.all.forEach((item) => {
              this.allItemsOther.push(item)

            })
          })
          .catch();
    },
    store_root(id) {
      if (this.title_root.length === 0) {
        toast.error('عامل ریشه ای اجباری است!')
        return;
      } else if (this.type_root.length === 0) {
        toast.error('نوع اجباری است!')
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('causes_id', parseInt(id))
      formdata.append('title', this.title_root)
      formdata.append('type', this.type_root)
      formdata.append('is_human', this.is_human_root === true ? 1 : 0)
      formdata.append('is_fund', this.money_root === true ? 1 : 0)
      formdata.append('is_technology', this.tech_root === true ? 1 : 0)
      formdata.append('is_management', this.management_root === true ? 1 : 0)
      formdata.append('other', this.other_root)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/save_RootCausesProblemAnalysis`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.resetData()
            this.fetchOther(id)


          })
          .catch();
    },

    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.status_seconder = false
            this.seconder_ban = false
            this.status_seconder_step = false
            this.approver_ban = false
            this.status_approver = false
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status) {
              this.status_show = true
            }
            this.allItems.length = 0
            response.all.forEach((item) => {
              this.allItems.push(item)

            })
            this.is_fetch = false
            this.setShow()
            if (!response.status_seconder) {
              if (response.status) {
                this.status_seconder = true
              }
            }
            if (!this.status_approver && this.$cookies.isKey('type_1')) {
              this.status_seconder = false
            }
            if (response.status && !response.status_approver) {
              this.status_seconder = true
            }
            if (response.seconder_ban) {
              this.seconder_ban = true
              this.textAlert = response.message ?? 'موردی یافت نشد'
            }
            if (response.approver_ban) {
              this.approver_ban = true
              this.textAlert = response.message ?? 'موردی یافت نشد'
            }

            if (response.status_approver) {
              this.status_approver = true
            }
            if (response.text_seconder) {
              this.seconder_ban = true
              this.textAlert = response.text_seconder ?? 'موردی یافت نشد'
            }
            if (parseInt(response.step) === 1) {
              this.status_seconder_step = true
              this.status_seconder = true
            }
            if (parseInt(response.step) === 2) {
              this.status_seconder_step = true
              this.status_seconder = false
            }
            if (parseInt(response.step) === 0) {
              this.status_seconder_step = false

            }
            this.show_insert = response.status_insert
            if ((parseInt(response.step) === 1 && this.type_two) || (parseInt(response.step) === 2 && this.type_two) || (parseInt(response.step) === 2 && this.type_one) || parseInt(response.step) === 3) {
              this.not_show = false
            }
          })
          .catch();
    },
    store() {
      let obj = []
      this.allItems.forEach((ele) => {
        const method = document.getElementById(`method_${ele.id}`).value
        const order_text = document.getElementById(`order_text_${ele.id}`)?.value

        const item = {
          'id': ele.root_causes_problem ? ele.root_causes_problem.id : '',
          'prioritizing_issues_id': ele.id,
          'order_text': order_text,
          'method': method,
        }
        obj.push(item)
      })

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('all', JSON.stringify(obj))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.all()

          })
          .catch();

    },
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }
    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.logout()
              return;
            }
            if (result['item']) {
              if (this.is_mother) {
                this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
    ProductivityPeriod() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ProductivityPeriod/check`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              this.isWrite = true
              return
            } else {
              this.isWrite = false
            }


          })
          .catch();
    },

  },
  mounted() {
    this.all()
    this.fetchItems()
    this.checkIsMother()
    this.ProductivityPeriod()

  },
}
</script>
<style scoped lang="scss">
img:hover {
  border-radius: 50%;
}

.input {
  display: block;
  margin-bottom: 1.5em;
  min-width: 10em;
}

.input:hover .input__support {
  border-color: #9fa8b2;
}

.input:hover .input__support:before {
  color: #7d8a96;
}

.input__text {
  display: block;
  padding-bottom: 0.5em;
  margin-left: 0.18em;
}

.input__text sup {
  color: #fe4f3e;
  cursor: help;
}

.input .input__support:before {
  display: none;

}

.input .input__support, .input .input__field {
  border-radius: 0;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid #c1c7cd;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input__field:focus + .input__support {
  border-color: #037DE4;
}

.input__field:valid + .input__support {
  border-color: #3742FA;
}

.input__field:valid + .input__support:before {
  content: "done";
  color: #3742FA;
}

.input__field:valid + .input__support .input__helper:before {
  content: "";
  color: #7d8a96;
}

.input__field:invalid + .input__support:before {
  content: "file_upload";
}

.input__field:invalid + .input__support .input__helper:before {
  content: "انتخاب فایل (فرمت های قابل قبول: ورد-پی دی اف - اکسل-تصاویر)";
}

.input__support {
  display: flex !important;
  align-items: center;
}

.input__support:before {
  content: "file_upload";
  display: inline-block;
  color: #9fa8b2;
  width: 1.2rem;
  height: 1.2rem;
  margin: -0.5rem 0.5rem -0.5rem -0.2rem;
  transition: color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input__helper:before {
  font-weight: 200;
  color: #9fa8b2;
  content: "Select file";
}

.input--file {
  cursor: pointer;
}

.input--file input[type=file] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  padding: 0;
}
</style>